<!-- <app-spinner-utileria *ngIf="spinner"></app-spinner-utileria> -->
<div class="flex flex-col flex-auto min-w-0">
    <div class="bg-card">
        <div class="flex flex-col min-w-0 ml-4">
            <ng-container *transloco="let t">
                <!-- <div class="text-2xl md:text-5xl font-semibold tracking-tight leading-7 md:leading-snug truncate">
                    {{t('Nuevo Cliente')}}</div> -->
            </ng-container>
        </div>
        <br>
        <hr>
        <mat-card-content>
            <form [formGroup]="formDatosCliente" class="row d-flex justify-content-start align-items-center">
                <div class="col-sm-12 col-md-12 col-xl-12 ">
                    <mat-label>Nombre / Razón Social:</mat-label>
                    <mat-form-field class="custom-field" appearance="outline">
                        <input matInput placeholder="Nombre / Razón Social" formControlName="nombreRazonSocial"
                            oninput="this.value = this.value.toUpperCase()"
                            onkeypress="return /^[a-zA-Z\s]*$/gi.test(event.key)" minlength="1">
                        <mat-error *ngIf="formDatosCliente.get('nombreRazonSocial').hasError ('required')"><strong>*Este
                                campo es obligatorio</strong></mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6 col-xl-6 ">
                    <mat-label>RFC:</mat-label>
                    <mat-form-field class="custom-field" appearance="outline">
                        <input matInput placeholder="RFC" formControlName="rFC" maxlength="13" minlength="12"
                            oninput="this.value = this.value.toUpperCase()"
                            pattern="(^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$)"
                            onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))">
                        <mat-error *ngIf="formDatosCliente.get('rFC').hasError ('required')"><strong>*Este campo es
                                obligatorio</strong></mat-error>
                        <mat-error *ngIf="formDatosCliente.get('rFC').hasError ('minlength')"><strong>*Este campo
                                requiere un minimo de
                                12 caractere</strong></mat-error>
                        <mat-error *ngIf="formDatosCliente.get('rFC').hasError ('pattern')"><strong>*RFC Incorrecta
                                verifique</strong></mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6 col-xl-6 ">
                    <mat-label>Uso de factura:</mat-label>
                    <mat-form-field class="custom-field" appearance="outline">
                        <mat-select placeholder="Seleccionar Uso de la factura" formControlName="usoDeLaFactura">
                            <mat-option *ngFor="let factura of usoFactura" [value]="factura.idUsoCFDI">
                                {{ factura.descripcion }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="formDatosCliente.get('usoDeLaFactura').hasError ('required')"><strong>*Este
                                campo es obligatorio</strong></mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-12 col-xl-12 ">
                    <mat-label>Régimen fiscal:</mat-label>
                    <mat-form-field class="custom-field" appearance="outline">
                        <mat-select placeholder="Seleccionar Uso de la factura" formControlName="regimenFiscal">
                            <mat-option [value]=0>
                                Selecciona el Régimen fiscal
                            </mat-option>
                            <mat-option *ngFor="let regimenFiscal of regFiscal" [value]="regimenFiscal.idCatalogo">
                                {{ regimenFiscal.descripcion }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="formDatosCliente.get('regimenFiscal').hasError ('required')"><strong>*Este
                                campo es obligatorio</strong></mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6 col-xl-6 ">
                    <mat-label>E-Mail:</mat-label>
                    <mat-form-field class="custom-field" appearance="outline">
                        <input type="email" [email]="true" matInput placeholder="E-Mail" formControlName="eMail"
                            onkeyup="if(this.value.length > 40){
                            this.value= this.value.slice(0,40)}">
                        <mat-error *ngIf="formDatosCliente.get('eMail').hasError ('required')"><strong>*Este campo es
                                obligatorio</strong></mat-error>
                        <mat-error *ngIf="formDatosCliente.get('eMail').hasError ('email')  "><strong>*El correo no es
                                válido</strong></mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6 col-xl-6 ">
                    <mat-label>E-Mail opcional No.1:</mat-label>
                    <mat-form-field class="custom-field" appearance="outline">
                        <input type="email" [email]="true" matInput placeholder="E-Mail"
                            formControlName="eMailOpcionalNo1" onkeyup="if(this.value.length > 40){
                           this.value= this.value.slice(0,40)}">
                        <mat-error *ngIf="formDatosCliente.get('eMailOpcionalNo1').hasError ('email')  "><strong>*El
                                correo no es válido</strong></mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6 col-xl-6 ">
                    <mat-label>E-Mail opcional No.2:</mat-label>
                    <mat-form-field class="custom-field" appearance="outline">
                        <input type="email" [email]="true" matInput placeholder="E-Mail"
                            formControlName="eMailOpcionalNo2" onkeyup="if(this.value.length > 40){
                           this.value= this.value.slice(0,40)}">
                        <mat-error *ngIf="formDatosCliente.get('eMailOpcionalNo2').hasError ('email')  "><strong>*El
                                correo no es válido</strong></mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-3 col-xl-3 ">
                    <mat-label>C.P:</mat-label>
                    <mat-form-field class="custom-field" appearance="outline">
                        <input matInput placeholder="C.P" formControlName="cP"
                            oninput="this.value = this.value.toUpperCase()"
                            onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode >= 65 && event.charCode <= 90) ||
                    (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32 || event.charCode == 209 || event.charCode == 241))">

                    </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-3 col-xl-3 ">
                    <button mat-raised-button class="fuse-mat-button-rounded" [color]="'primary'" mat-flat-button
                        (click)="consultarCP()">Consultar</button>
                </div>
                <!-- <div class="col-sm-12 col-md-2 col-xl-2 ">
                    <button class="colorLetra" (click)="mostrarDatosAdicionales()" onMouseover="this.style.color='blue'" onMouseout="this.style.color='black'">Agregar datos opcionales</button>
                </div> -->
            </form>
            <form [formGroup]="formDatosClienteAdicionales" *ngIf="datosAdicionales"
                class="row d-flex justify-content-start align-items-center">
                <div class="col-sm-12 col-md-12 col-xl-12 ">
                    <mat-label>Calle:</mat-label>
                    <mat-form-field class="custom-field" appearance="outline">
                        <input matInput placeholder="Calle" formControlName="calle" maxlength="30"
                            oninput="this.value = this.value.toUpperCase()"
                            onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)
                        || (event.charCode >= 44 && event.charCode <= 46) || (event.charCode == 32 || event.charCode == 209 || event.charCode == 241))" />
                        <mat-error *ngIf="formDatosClienteAdicionales.get('calle').hasError ('required')"><strong>Campo
                                Requerido</strong></mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6 col-xl-6 ">
                    <mat-label>No. Exterior:</mat-label>
                    <mat-form-field class="custom-field" appearance="outline">
                        <input matInput placeholder="No. Exterior" formControlName="noExterior"
                            oninput="if(this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value==0 && this.value != ''){this.value= ''}"
                            onkeypress="return ((event.charCode >= 48 && event.charCode <= 57))" />
                        <mat-error *ngIf="formDatosClienteAdicionales.get('noExterior').hasError('required')">
                            <strong>Verifica
                                este campo </strong>
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6 col-xl-6 ">
                    <mat-label>No. Interior:</mat-label>
                    <mat-form-field class="custom-field" appearance="outline">
                        <input matInput placeholder="No. Interior" formControlName="noInterior"
                            onkeyup="if(this.value<0){this.value= this.value * -1} if(this.value == 0){this.value = ''}"
                            oninput="if(this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                            onkeypress="return ((event.charCode >= 48 && event.charCode <= 57))" />
                        <mat-error *ngIf="formDatosClienteAdicionales.get('noInterior').hasError('required')">
                            <strong>Campo
                                Requerido </strong>
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-12 col-xl-12 ">
                    <mat-label>País:</mat-label>
                    <mat-form-field class="custom-field" appearance="outline">
                        <mat-select name="tipo" placeholder="Seleccione" formControlName="pais"
                            [disabled]="bloquearPaEsMun" (selectionChange)="changePais($event.value)">
                            <mat-option *ngFor="let pais of lstPais" [value]="pais.idPais">
                                {{ pais.nombre }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="formDatosClienteAdicionales.get('pais').hasError ('required')"><strong>Campo
                                Requerido</strong></mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-12 col-xl-12 ">
                    <mat-label>Estado: </mat-label>
                    <mat-form-field class="custom-field" appearance="outline">
                        <mat-select name="tipo" placeholder="Seleccione" formControlName="estado"
                            [disabled]="bloquearPaEsMun" (selectionChange)="changeEntidad($event.value)">
                            <mat-option *ngFor="let estado of lstEstado" [value]="estado.idEstado">
                                {{ estado.nombre }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="formDatosClienteAdicionales.get('estado').hasError ('required')"><strong>Campo
                                Requerido</strong></mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-12 col-xl-12 ">
                    <mat-label>Municipio: </mat-label>
                    <mat-form-field class="custom-field" appearance="outline">
                        <mat-select name="tipo" placeholder="Seleccione" formControlName="municipio"
                            [disabled]="bloquearPaEsMun" (selectionChange)="changeMunicipio($event.value)">
                            <mat-option *ngFor="let municipio of lstMunicipio" [value]="municipio.idMunicipio">
                                {{ municipio.nombre }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="formDatosClienteAdicionales.get('municipio').hasError ('required')">
                            <strong>Campo
                                Requerido</strong>
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-12 col-xl-12 ">
                    <mat-label>Colonia: </mat-label>
                    <mat-form-field class="custom-field" appearance="outline">
                        <mat-select name="tipo" placeholder="Seleccione" formControlName="colonia">
                            <mat-option *ngFor="let asentamiento of lstAsentamiento"
                                [value]="asentamiento.idAsentamiento">
                                {{ asentamiento.nombre }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="formDatosClienteAdicionales.get('colonia').hasError ('required')">
                            <strong>Campo
                                Requerido</strong>
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-12 col-xl-12 ">
                    <mat-label>Localidad: </mat-label>
                    <mat-form-field class="custom-field" appearance="outline">
                        <!-- (selectionChange)="changeColonia($event.value)" -->
                        <mat-select name="tipo" placeholder="Seleccione" formControlName="localidad"
                            >
                            <mat-option *ngFor="let asentamiento of lstAsentamiento"
                                [value]="asentamiento.idAsentamiento">
                                {{ asentamiento.nombre }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="formDatosClienteAdicionales.get('localidad').hasError ('required')">
                            <strong>Campo
                                Requerido</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
            </form>
            <hr>
            <div class="row">
                <div class="col-12 d-flex justify-content-end f12">

                    <button mat-raised-button (click)="cerrarCliente()"> <span>Cerrar</span></button>
                    &nbsp;&nbsp;
                    <button *ngIf="!modificarDatos" mat-raised-button class="fuse-mat-button-rounded"
                        [color]="'primary'" mat-flat-button (click)="InsertarCliente()"><span
                            [style.color]="'#FFFFFF'">Guardar</span> </button>
                    <button *ngIf="modificarDatos" mat-raised-button class="fuse-mat-button-rounded" [color]="'primary'"
                        mat-flat-button (click)="UPDCliente()"><span [style.color]="'#FFFFFF'">Modificar</span>
                    </button>
                </div>
            </div>
            <br>
        </mat-card-content>
    </div>
</div>
